import { EstablishEntityIBANsClientRequest } from '../../../@types/establishEntityIbans'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'

export const useEstablishEntityIbansPayload = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()

  const handleEstablishEntityIbansPayload = (iban = '') => {
    const payload: EstablishEntityIBANsClientRequest = {
      iban,
      entityId: policyholderDetailsSelected?.idEntity || '',
      entityType: policyholderDetailsSelected?.entityType || '',
    }

    return payload
  }

  return {
    handleEstablishEntityIbansPayload,
  }
}
